<i18n>
{
	"no": {
		"title": "Valideringsfeil på oppdrag"
	}
}

</i18n>
<template>
	<t-dialog
		:isShown="isShown"
		:title="$t('title')"
		icon="order"
		iconColor="blue"
		width="450px"
		@close="$emit('closeDialog')"
		@ok="$emit('closeDialog')"
	>
		<div>
			<div style="height:200px; width:400px">
				<ValidationResults
					:orderValidationResults="validationResults"
				/>
			</div>
		</div>
	</t-dialog>
</template>

<script>

import ValidationResults from './ValidationResults';
export default {

	components: {
		ValidationResults
	},
	props: {
		validationResults: Array,
		isShown: Boolean,
		orderNumber: Number
	}
};
</script>

<style>

</style>